import { useAppStore } from "@hooks/useAppStore";
import {
	CustomListSubheader,
	type CustomListSubheaderProps,
} from "@memorang/ui";

const CustomListSubheaderContainer = (props: CustomListSubheaderProps) => {
	const appFont = useAppStore((store) => store.app.font);
	return <CustomListSubheader {...props} font={appFont} />;
};

export default CustomListSubheaderContainer;
